import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ai_cover_video_item_active",
  "use": "icon-ai_cover_video_item_active-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ai_cover_video_item_active\">\n<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"8\" fill=\"#B84EFF\" />\n<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"8\" stroke=\"#B84EFF\" stroke-width=\"2\" />\n<path d=\"M8.5625 12.3437L10.9817 14.7629C11.1554 14.9366 11.4433 14.9141 11.5879 14.7155L15.75 9\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol